import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import PayerDataService from '../../../../services/PayerDataService'
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice'; 
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import { componentKey, setLoadingState, setPermissions, setThresholdAmount, setRightsLabels, setDisabledPermissions } from './RightsManagementSlice';
import RightsManagementDataService from '../../../../services/RightsManagementDataService';

export const { getPermissions, getThresholdAmount, getRightsLabels, getDisabledPermissions, updateThresholdAmount, updatePermissions } = {
    getPermissions: (payload) => {
        return {
            type: "USERS/GET_PERMISSIONS",
            payload: payload
        }
    },
    getThresholdAmount: (payload) => {
        return {
            type: "USERS/GET_THRESHOLD_AMOUNT",
            payload: payload
        }
    },
    getRightsLabels: (payload) => {
        return {
            type: "USERS/GET_RIGHTS_LABELS",
            payload: payload
        }
    },
    getDisabledPermissions: (payload) => {
        return {
            type: "USERS/GET_DISABLED_PERMISSIONS",
            payload: payload
        }
    },
    updateThresholdAmount: (payload) => {
        return {
            type: "USERS/UPDATE_THRESHOLD_AMOUNT",
            payload: payload
        }
    },
    updatePermissions: (payload) => {
        return {
            type: "USERS/UPDATE_PERMISSIONS",
            payload: payload
        }
    },
}

function* getPermissionsAsync() {
    try {

        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Permissions......" }));
        
        const response = yield RightsManagementDataService.loadPermissions();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setPermissions([...response.data.Data]))
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* getThresholdAmountAsync() {
    try {

        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Getting Threshold Amount......" }));
        
        const response = yield RightsManagementDataService.getThresholdAmount();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setThresholdAmount(response.data.Data))
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getRightsLabelsAsync() {
    try {

        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Threshold Amount......" }));
        
        const response = yield RightsManagementDataService.getRightsLabels();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setRightsLabels(response.data.Data))
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* getDisabledPermissionsAsync() {
    try {

        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Threshold Amount......" }));
        
        const response = yield RightsManagementDataService.getDisabledPermissions();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setDisabledPermissions(response.data.Data))
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* updateThresholdAmountAsync(action) {
    try {

        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Updating Threshold Amount......" }));
        
        const response = yield RightsManagementDataService.updateThresholdAmount(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setThresholdAmount(response.data.Data))
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* updatePermissionsAsync(action) {
    try {

        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Updating Permissions......" }));
        
        const response = yield RightsManagementDataService.updatePermissions(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield call ( getPermissionsAsync )
        }

    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPermissions().type, getPermissionsAsync),
        takeLatest(getThresholdAmount().type, getThresholdAmountAsync),
        takeLatest(getDisabledPermissions().type, getDisabledPermissionsAsync),
        takeLatest(getRightsLabels().type, getRightsLabelsAsync),
        takeLatest(updateThresholdAmount().type, updateThresholdAmountAsync),
        takeLatest(updatePermissions().type, updatePermissionsAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);